import { createRoot } from "react-dom/client";
import { AppErrorBoundary } from "@/components/app/AppErrorBoundary";
import { setupGlobalErrorHandlers } from "@/lib/monitoring";
import App from "./App.tsx";
import "./index.css";

setupGlobalErrorHandlers();

createRoot(document.getElementById("root")!).render(
  <AppErrorBoundary>
    <App />
  </AppErrorBoundary>
);
